<template>
  <div v-if="form !== null">

    <div class="columns">
      <div class="column is-4">
        <image-control :image-id="form.image_id"
                       v-model="form.image_id"
                       @event="form.listen(form, $event)"></image-control>

        <form-group type="select"
                    id="company"
                    label="Show On Company Website</small>"
                    v-model="form.company"
                    :error="form.errors.get('company')"
                    @event="form.listen(form, $event)"
                    :option_name="'name'"
                    :option_value="'value'"
                    :options="[
                    {name: 'All Companies', value: ''},
                    {name: 'Crockett', value: 'CF'},
                    {name: 'Bells', value: 'BELLS'},
                ]">
        </form-group>

        <form-group type="text"
                    id="name"
                    label="Page name <small><em>(shown in links to this page)</em></small>"
                    v-model="form.name"
                    :error="form.errors.get('name')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    id="title"
                    label="Page title <small><em>(shown on the page and in the browser title)</em></small>"
                    v-model="form.title"
                    :error="form.errors.get('title')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    id="slug"
                    label="Page slug <small><em>(the page URL, tell Andy when changing)</em></small>"
                    v-model="form.slug"
                    :error="form.errors.get('slug')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    id="keywords"
                    label="Page keywords <small><em>(for SEO, google searches, etc)</em></small>"
                    v-model="form.keywords"
                    :error="form.errors.get('keywords')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="textarea"
                    id="description"
                    label="Page description <small><em>(for SEO)</em></small>"
                    v-model="form.description"
                    :error="form.errors.get('description')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="checkbox"
                    id="enabled"
                    label="List page on frontend"
                    v-model="form.enabled"
                    :error="form.errors.get('enabled')"
                    @event="form.listen(form, $event)">
        </form-group>

        <button type="button" class="button is-primary"
                :disabled="apiBusy"
                @click="updatePage()">
          Save Page Details
        </button>
      </div>
      <div class="column is-8">
        <h2 class="subtitle has-text-centered">
          Page Contents
          <br />
          <small>(updates automatically)</small>
        </h2>
        <page-content v-for="content in contents"
                      :content="content"
                      :key="content.id"></page-content>
        <page-content :page-id="parseInt($route.params.id)"></page-content>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters}  from "vuex"
import Form          from "../../helpers/Form"
import {UPDATE_PAGE} from "../../store/mutation-types"

export default {
  name: 'page-edit',
  data() {
    return {
      form: new Form(this, this.$store.state.pages.all.find(page => {
        return page.id === parseInt(this.$route.params.id)
      }), UPDATE_PAGE)
    }
  },
  computed: Object.assign({}, mapGetters(['apiBusy', 'pageContents', 'products', 'bundles']), {
    contents() {
      return this.pageContents.filter(content => {
        return content.page_id === parseInt(this.$route.params.id)
      }).sort((a, b) => {
        return a.sort - b.sort
      })
    }
  }),
  methods: {
    updatePage() {
      this.form.submit().then(data => {
        this.form = null;
        setTimeout(() => {
          this.form = new Form(this, data, UPDATE_PAGE)
        }, 0)
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageEdit.vue?4ae5ed54